module.exports = __webpack_public_path__ + "img/pkw.286f35a2.png";